import React, { useState } from 'react';
import { Box, Button, Checkbox, Divider, FormControlLabel, FormGroup, Grid, Stack, Typography } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import Accordian from '../../components/Accordian/Accordian';
import IAction from '../../types/action';
import Chip from '../../components/Chip/Chip';
import TextField from '../../components/TextField/TextField';
import Select from '../../components/Select';
import { taskOutcomes } from '../../mock/Actions';
import { updateActionStatus } from '../../services/action';

interface IProps {
  action: IAction;
  toggleRefresh: () => void;
  i: number;
}

const ActionRequired: React.FC<IProps> = ({ action, toggleRefresh, i }) => {
  const { id, name, dueDate, tasks } = action;
  const [expanded, setExpanded] = useState(i === 0);

  const header = (
    <Box gap={0.5}>
      <Typography variant="body1" fontWeight={500}>
        {name}
      </Typography>
      <Stack divider={<Divider orientation="vertical" flexItem />} direction="row" gap={1.5}>
        <Typography fontSize={12} fontWeight={400}>
          Assigned to Jereme Belle
        </Typography>
        <Typography fontSize={12} color={(theme) => theme.palette.error.light} fontWeight={400}>
          Due on {dueDate}
        </Typography>
      </Stack>
    </Box>
  );
  const handleChange = (actionId: string, status: string) => {
    updateActionStatus(actionId, status === 'Completed' ? 'NotStarted' : 'Completed').then(() => {
      toggleRefresh();
    });
  };
  const taskList = tasks.map((task) => (
    <Stack key={task.id} justifyContent="space-between" direction="row">
      <Typography variant="body2">{task.name}</Typography>
      <LaunchIcon color="primary" fontSize="inherit" />
    </Stack>
  ));
  return (
    <Accordian
      key={id}
      header={header}
      styleVariant="secondary"
      expanded={expanded}
      onChange={() => setExpanded((prev) => !prev)}
    >
      <FormGroup>
        <Box gap={1} display="flex" flexDirection="column">
          {taskList}
          <Grid container gap={1.375} alignItems="center" mt={0.5}>
            <Grid item>
              <Select title="Task outcome" options={taskOutcomes} />
            </Grid>
            <Grid item xs>
              <TextField placeholder="Enter comment" sx={{ fontSize: 12, height: 36 }} />
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                sx={{
                  textTransform: 'none',
                  height: 'fit-content',
                  fontSize: '12px',
                  padding: '10px',
                  lineHeight: 'inherit',
                }}
                disabled
              >
                Mark as Complete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </FormGroup>
    </Accordian>
  );
};

export default ActionRequired;
